<template>
  <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
    <div class="w-full h-36px">
      <div class="float-right">
        <el-button v-if="handleEditType === 'create'" type="primary" @click="applyAPi()"
          >申请</el-button
        >
        <el-button v-if="handleEditType === 'edit'" type="primary" @click="updateAPi()"
          >保存</el-button
        >
        <el-button @click="goBack()">返回</el-button>
      </div>
    </div>
    <el-row :gutter="10" class="mt-20px" style="height: 196px">
      <el-form :model="applyForm" ref="applyForm" :rules="applyRules" label-width="120px">
        <el-col :span="8">
          <el-form-item :label="$t('申请部门')" prop="applyDepartment">
            <el-select
              size="small"
              v-model="applyForm.applyDepartment"
              class="w-full"
              :disabled="handleEditType === 'read'"
              allow-create
              clearable
              filterable
              :placeholder="$t('请选择申请部门')"
            >
              <el-option
                v-for="item in organizationList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('申请应用')" prop="name">
            <el-input
              size="small"
              :placeholder="$t('请输入申请应用')"
              :readonly="handleEditType === 'read'"
              v-model="applyForm.name"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('申请人')" prop="applyUser">
            <el-select
              size="small"
              v-model="applyForm.applyUser"
              class="w-full"
              :disabled="handleEditType === 'read'"
              allow-create
              clearable
              filterable
              :placeholder="$t('请选择申请人')"
            >
              <el-option
                v-for="item in userList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('API接口')" prop="apiIds">
            <el-select
              size="small"
              v-model="applyForm.apiIds"
              class="w-full apiIds"
              :disabled="handleEditType === 'read' && isDisabled"
              multiple
              filterable
              :collapse-tags="isCollapseTags"
              :placeholder="$t('pleaseSelect')"
            >
              <el-option v-for="item in apiData" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('创建人')" prop="createdUser">
            <el-input
              size="small"
              placeholder="创建人"
              readonly
              :value="userInfo ? userInfo.name : ''"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="密钥" prop="secretKey">
            <div class="flex">
              <el-input
                size="small"
                :placeholder="$t('请生成密钥')"
                readOnly
                v-model="applyForm.secretKey"
              />
              <el-button
                type="primary"
                @click="generateSecretKey()"
                class="ml-10px"
                :disabled="handleEditType === 'read'"
                >生成密钥</el-button
              >
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('申请描述')" prop="description">
            <el-input
              :disabled="handleEditType === 'read'"
              size="small"
              type="textarea"
              :placeholder="$t('申请用途描述')"
              v-model="applyForm.description"
            />
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
    <el-card style="height: calc(100% - 252px)" :body-style="{ height: '100%' }">
      <div class="height-40">
        <el-form :inline="true" :model="searchCondition" class="demo-form-inline">
          <el-form-item>
            <el-input
              :readonly="handleEditType === 'read'"
              v-model="searchCondition.keyword"
              clearable
              size="small"
              placeholder="编码/名称"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-select
              :disabled="handleEditType === 'read'"
              class="w-full"
              v-model="searchCondition.type"
              placeholder="请选择类型"
              filterable
              allow-create
              clearable
              size="small"
            >
              <el-option
                v-for="item in apiTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item>
            <el-select
              size="small"
              clearable
              :disabled="handleEditType === 'read'"
              v-model="searchCondition.state"
              placeholder="状态"
            >
              <el-option
                :label="item.label"
                :value="item.value"
                v-for="(item, index) in statusList"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item>
            <el-button v-if="handleEditType !== 'read'" type="primary" @click="searchTableData()"
              >搜索</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <!-- table start -->
      <el-table
        :data="tableData"
        border
        height="calc(100% - 98px)"
        v-loading="tableLoading"
        class="mt-10px"
      >
        <el-table-column :label="$t('名称')" prop="name"></el-table-column>
        <el-table-column :label="$t('类型')" prop="type"></el-table-column>
        <el-table-column :label="$t('描述')" prop="description"></el-table-column>
        <el-table-column :label="$t('状态')" width="120" prop="statusName"> </el-table-column>
        <el-table-column label="是否启用" width="120">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.isEnabled" disabled></el-switch>
          </template>
        </el-table-column>
        <el-table-column :label="$t('操作')" width="200">
          <template slot-scope="scope">
            <el-button
              :disabled="handleEditType === 'read' || _.includes(applyForm.apiIds, scope.row.id)"
              size="mini"
              @click="handleRow(scope.row, 'apply')"
              >申请</el-button
            >
            <el-button size="mini" @click="handleRow(scope.row, 'read')">详情</el-button>
            <el-button
              size="mini"
              :disabled="check !== 'verify' && !_.includes(applyForm.apiIds, scope.row.id)"
              @click="toVerify(scope.row.id)"
              >验证</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- table end -->
      <!-- pagigation start -->
      <el-pagination
        class="mt-10px r"
        background
        @size-change="searchTableData()"
        @current-change="findTableData()"
        :current-page.sync="page.pageNo"
        :page-sizes="$pageSizeAll"
        :page-size.sync="page.pageSize"
        layout="->, total, sizes, prev, pager, next"
        :total="page.pageTotal"
      ></el-pagination>
      <!-- pagigation end -->
    </el-card>
  </el-card>
</template>
<script>
import { ApplyApplicationApi, OpenApiApi } from '@wiz-api/open-api-management'

const applyApplicationApi = new ApplyApplicationApi()
const openApiApi = new OpenApiApi()
export default {
  name: 'apiApply',
  components: {},
  data() {
    return {
      apiData: [],
      handleEditType: 'create',
      tableLoading: true,
      apiTypes: [],
      tableData: [],
      apiMethods: [], // api请求方式
      searchCondition: {
        keyword: '',
        type: '',
        state: '',
      },
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      applyForm: {
        flag: 0,
        applyDepartment: '',
        name: '',
        applyUser: '',
        description: '',
        apiIds: [],
        secretKey: null,
      },
      applyRules: {
        applyDepartment: [
          {
            required: true,
            message: '请输入申请部门',
            trigger: 'change',
          },
        ],
        name: [
          {
            required: true,
            message: '请输入申请应用',
            trigger: 'blur',
          },
        ],
        applyUser: [
          {
            required: true,
            message: '请输入申请人',
            trigger: 'change',
          },
        ],
        apiIds: [
          {
            required: true,
            message: '请选择API接口',
            trigger: 'change',
          },
        ],
        secretKey: [
          {
            required: true,
            message: '请生成密钥',
            trigger: 'change',
          },
        ],
      },
      userInfo: Wiz.AuthHooks.GetUserInfo().profile,
      currentEnv: Wiz.GetModuleConfig('legacy-resource').currentEnv,
      userList: [],
      statusList: [],
      check: '',
      isCollapseTags: false,
      isDisabled: false,
    }
  },
  computed: {
    organizationList() {
      return this.$store.getters['System/organizationList']
    },
    tableHeight() {
      return `${window.innerHeight - 520}px`
    },
  },
  methods: {
    // api验证
    toVerify(id) {
      this.$router.push({
        path: './api-release-create',
        query: {
          id,
          type: 'verify',
          applyApplicationId: this.$route.query.id ? this.$route.query.id : '',
        },
      })
    },
    // 生成密钥
    async generateSecretKey() {
      const [err, res] = await applyApplicationApi.generateSecretKey()
      if (!err) {
        this.applyForm.secretKey = res
      }
    },
    // 获取状态
    async getStatus() {
      const [err, res] = await openApiApi.getStatus()
      if (!err) {
        this.statusList = _.map(res, (item) => {
          return {
            label: item.item2,
            value: item.item1,
          }
        })
      }
    },
    /**
     * @function 获取用户
     */
    async getCharactor() {
      const fileServer = Wiz.GetModuleServer('system-management')
      const res = await axios.get(
        `${fileServer}/api/eaf-user-role/get-users?SkipCount=0&MaxResultCount=999`
      )
      if (res && res.data && res.status === 200) {
        this.userList = res.data.items
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    applyAPi() {
      this.$refs.applyForm.validate(async (valid) => {
        if (valid) {
          const applyOpenApiRecords = []
          _.map(this.applyForm.apiIds, (item) => {
            applyOpenApiRecords.push({ openApiId: item, flag: 0 })
          })
          const params = _.cloneDeep(this.applyForm)
          delete params.apiIds
          params.applyOpenApiRecords = applyOpenApiRecords
          const [err, res] = await applyApplicationApi.create({
            body: params,
          })
          if (!err) {
            this.$message.success('申请成功')
          }
        }
      })
    },
    updateAPi() {
      this.$refs.applyForm.validate(async (valid) => {
        if (valid) {
          const applyOpenApiRecords = []
          _.map(this.applyForm.apiIds, (item) => {
            applyOpenApiRecords.push({ openApiId: item, flag: 0 })
          })
          const params = _.cloneDeep(this.applyForm)
          delete params.apiIds
          params.applyOpenApiRecords = applyOpenApiRecords
          const [err, res] = await applyApplicationApi.update(this.applyForm.id, {
            body: params,
          })
          if (!err) {
            this.$message.success('修改成功')
          }
        }
      })
    },
    handleRow(row, type) {
      if (type === 'apply') {
        this.applyForm.apiIds.push(row.id)
        return
      }
      this.$router.push(`./api-release-create?id=${row.id}&type=${type}`)
    },
    async findApiType() {
      const [err, res] = await openApiApi.getDistinctApiType()
      if (!err) {
        this.apiTypes = _.map(res, (item) => {
          return {
            label: item,
            value: item,
          }
        })
      }
    },
    searchTableData() {
      this.page.pageNo = 1
      this.findTableData()
    },
    async findAllApi() {
      const reqData = {
        skipCount: 1,
        maxResultCount: 999,
        sorting: '',
        keywords: '',
        type: '',
        status: 2, // 已发布
        // applicationid: this.$route.query.type !== 'edit' ? this.$route.query.id : '',
      }
      const [err, res] = await openApiApi.getList(reqData)
      if (!err) {
        this.apiData = res.items
      }
    },
    async findTableData() {
      const reqData = {
        skipCount: this.page.pageNo,
        maxResultCount: this.page.pageSize,
        sorting: '',
        keywords: this.searchCondition.keyword,
        type: this.searchCondition.type,
        status: 2, // 已发布
        // applicationid: this.$route.query.type !== 'edit' ? this.$route.query.id : '',
      }
      this.tableLoading = true
      const [err, res] = await openApiApi.getList(reqData)
      this.tableLoading = false
      if (!err) {
        this.tableData = res.items
        // this.apiData = _.unionBy([...this.apiData, ...res.items], 'id')
        this.page.pageTotal = res.totalCount
        _.forEach(this.tableData, (item) => {
          item.isEnabled = item.isEnabled === 1 // 0:否 1:是
        })
      }
    },
    async findDetail(id) {
      const [err, res] = await applyApplicationApi.get(id)
      if (!err) {
        this.applyForm = res
        const list = []
        _.map(res.applyOpenApiRecords, (item) => {
          list.push(item.openApiId)
        })
        this.$set(this.applyForm, 'apiIds', list)
      }
    },
    // 监听元素高度
    watchElementHeight() {
      const MutationObserver =
        window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver
      const element = document.getElementsByClassName('apiIds')[0]
      this.observer = new MutationObserver(() => {
        const height = getComputedStyle(element).getPropertyValue('height')
        const eleHeight = height.slice(0, height.length - 2)
        if (Number(eleHeight) > 40) {
          this.isCollapseTags = true
        }
      })
      this.observer.observe(element, {
        attributes: true,
        subtree: true,
        characterData: true,
        attributeFilter: ['style'],
        attributeOldValue: true,
      })
    },
  },
  async created() {
    this.check = this.$route.query.check ? '' : ''
    await this.getCharactor()
    await this.findApiType()
    await this.searchTableData()
    await this.findAllApi()
    // await this.getStatus()
    if (!_.isEmpty(this.$route.query)) {
      this.handleEditType = this.$route.query.type
      this.findDetail(this.$route.query.id)
    }
  },
  mounted() {
    setTimeout(() => {
      if (this.handleEditType === 'read') {
        this.isDisabled = true
      }
    }, 3000)
    this.watchElementHeight()
  },
}
</script>
